import type { RecordView } from '@kit/sync/types/record-view';
import { type DocumentCategory, documentCategorySchema } from '@/entities/document/schemas/document-category';
import type { KitDocument } from '@/entities/document/schemas/kit-document';
import { localeStore } from '@/shared/i18n/locale-store';
import { matchesQuery } from '@/shared/lib/text/matches-query';

type DocumentGroup = {
  readonly category: DocumentCategory;
  readonly docs: RecordView<KitDocument>[];
};

export function groupDocuments(docs: readonly RecordView<KitDocument>[], query: string): DocumentGroup[] {
  const found = docs.filter(({ data }) =>
    matchesQuery(
      query,
      data.title,
      data.holder,
      data.notes,
      data.original_location,
      data.attachments.map((a) => a.name),
    ),
  );
  return documentCategorySchema.options
    .map((category) => ({
      category,
      docs: found
        .filter((view) => view.data.category === category)
        .sort((a, b) => a.data.title.localeCompare(b.data.title, localeStore.read())),
    }))
    .filter((group) => group.docs.length > 0);
}
